export const LocalStorageConstants = {
  OKTA_TOKEN: "okta-token-storage",
};
